import { OBJ } from "./listConstants";

export const APP_KEYS = {
    CRM: 'crm',
    MARKETING: 'marketing',
    SPEICHERFUCHS: 'speicherfuchs',
    OMS: 'oms',
    TRAINING: 'training',
    SETTINGS: 'settings',
    SAVVYSPEAK: 'savvyspeak'
};
